import { Box, Typography, styled } from '@mui/material';
import { CategoryList } from '../AppDetails';
import type { IAppDetailsAppData } from '../common-types';

const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
}));

type ClinicalFeaturesProps = {
  app: IAppDetailsAppData;
  translatedText: {
    clinicalFeaturesHeading: string;
  };
};

/**
 * ClinicalFeatures from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param translatedText is required, this is the text that as already been translated by the consumer of this component.
 */
export const ClinicalFeatures = ({
  app,
  translatedText,
  ...props
}: ClinicalFeaturesProps) => {
  const { clinicalFeatures } = app ?? {};
  return (
    <>
      {clinicalFeatures && clinicalFeatures.length > 0 && (
        <Container {...props}>
          <Box sx={{ display: 'grid', gap: (theme) => theme.spacing(3) }}>
            <Typography component="h2" variant="h6">
              {translatedText?.clinicalFeaturesHeading}
            </Typography>
            <CategoryList items={clinicalFeatures} />
          </Box>
        </Container>
      )}
    </>
  );
};
